import axios from "axios";

const VerifyApi = axios.create({
  baseURL: "https://evo.beeasy.digital/chat/whatsappNumbers/rifa365",
  headers: {
    apikey: 278662,
  },
});

export default {
    checkNumber: (formattedPhone) => {
        return VerifyApi.post("", {
            numbers: [formattedPhone],
        });
    }
}
